import { render, staticRenderFns } from "./TransferToAfropayModal.vue?vue&type=template&id=8ca258fc&scoped=true&"
import script from "./TransferToAfropayModal.vue?vue&type=script&lang=js&"
export * from "./TransferToAfropayModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferToAfropayModal.vue?vue&type=style&index=0&id=8ca258fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca258fc",
  null
  
)

export default component.exports